import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import PageContext from "./PageContext";
import useLocalStorageState from 'use-local-storage-state'
import { getDisplayName } from "../../utils";

const withPageContext = ( Component : React.FC ) => {

    const WrapperComponent = ( props : any ) => {

      const timezoneList = [
        {
          id : 'jst',
          utcOffset : 9,
          zonename : 'UTC+9'
        },
        {
          id : 'pdt',
          utcOffset : -8,
          zonename : 'UTC-8'
        },
        {
          id : 'bst',
          utcOffset : 0,
          zonename : 'UTC+0'
        },
        {
          id : 'hdp',
          utcOffset : 1,
          zonename : 'CET'
        },
        {
          id : 'mesz',
          utcOffset : 1,
          zonename : 'CET'
        },
        {
          id : 'aest',
          utcOffset : 11,
          zonename : 'UTC+11'
        }
      ]
      const [ timezone, setTimezoneContext ] = useState(0);

      const fanartCategory = ['ilw','phw','ssa','ssu'];

      const votingCategory = [`excellent`,`good`,`cool`,`cute`,`funny`,`relatable`];
      const defaultVotingState = useMemo(() => {
        let tempObj = {}
        fanartCategory.forEach((i) => {
          tempObj[i] = {};
          votingCategory.forEach((key) => {
            tempObj[i][key] = "";
          });
        });
        return tempObj;
      })

      const [ votingStatus, setVotingStatus ] = useLocalStorageState("fanartVoting_2024", {
          defaultValue: defaultVotingState
      });
      const [ votingBlockStatus, setVotingBlockStatus ] = useLocalStorageState("fanartVoting_2024_blockOpened", false);


      return (
        <PageContext.Provider value={{
          pageContext :props.pageContext,
          location : props.location,
          timezone : timezone,
          setTimezoneContext : setTimezoneContext,
          timezoneList : timezoneList,
          votingCategory : votingCategory,
          votingStatus : votingStatus, 
          setVotingStatus : setVotingStatus,
          votingBlockStatus : votingBlockStatus, 
          setVotingBlockStatus : setVotingBlockStatus
          }}>
          <Component {...props} />
        </PageContext.Provider>
      );
    };


    WrapperComponent.displayName = `PageContext(${getDisplayName(Component)})`;

    return WrapperComponent;
};

withPageContext.propTypes = {
    children: PropTypes.node.isRequired
};

export default withPageContext;
